import React from 'react'
import { useParams } from 'react-router-dom'
import { AssessmentDetails } from 'src/components/AssessmentDetails'
import { useLazyGetSurvivorAssessmentDetailsQuery } from 'src/store/APIs/assessments'
import { useGetSurvivorQuery } from 'src/store/APIs/survivors'

interface SurvivorAssessmentDetailsProps {}

export const SurvivorAssessmentDetails: React.FC<
  SurvivorAssessmentDetailsProps
> = () => {
  const { id } = useParams<{ id: string }>()
  const { data } = useGetSurvivorQuery(id)

  return (
    <AssessmentDetails
      useLazyQuery={useLazyGetSurvivorAssessmentDetailsQuery}
      user={data}
    />
  )
}
